import {
	SHOW_SNACKBAR,
	CLOSE_SNACKBAR,
	RELOAD_HEADER,
	LOGIN_MOBILE,
	PROFILE_TAB,
} from './contant'

const initState = {
	showSnackbar: {
		open: false,
		content: '',
		severity: 'success',
	},
	profileTab: 1,
	coinHeader: 1,
	phone: '',
}
const reducer = (state = initState, actions) => {
	switch (actions.type) {
		case SHOW_SNACKBAR:
			return {
				...state,
				showSnackbar: actions.data,
			}
		case CLOSE_SNACKBAR:
			return {
				...state,
				showSnackbar: {
					...state.showSnackbar,
					open: actions.data,
				},
			}
		case RELOAD_HEADER:
			return {
				...state,
				reloadHeader: actions.data,
			}
		case LOGIN_MOBILE:
			return {
				...state,
				phone: actions.data,
			}
		case PROFILE_TAB:
			return {
				...state,
				profileTab: actions.data,
			}

		default:
			return state
	}
}
export default reducer
